/* Shared browse-first timing for the existing Klaviyo offer. Runtime/tracking still loads only after qualification; time carries across pages.
 * Events: https://developers.klaviyo.com/en/docs/track_klaviyo_form_activity_using_javascript
 */
(() => {
  'use strict';
  if (window.__mfSubscribeGate) return;
  window.__mfSubscribeGate = true;
  const entry = document.currentScript || document.querySelector('script[data-mf-subscribe-home]');
  const key = 'morfone-subscribe-dismissed-v1';
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(key) === 'true'; } catch (_) { /* In-memory fallback for this page. */ }
  const remember = () => {
    dismissed = true;
    try { sessionStorage.setItem(key, 'true'); } catch (_) { /* Do not store any submitted fields. */ }
  };
  const popupIds = new Set();
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail || {};
    if (detail.companyId && detail.companyId !== 'StWn6c') return;
    const id = detail.formId || detail.formID;
    if (detail.type === 'open' && id) popupIds.add(id);
    // Do not read or persist email, phone number, or other form metadata.
    if (detail.type === 'close' || detail.type === 'submit') {
      if (detail.type === 'submit' || !id || popupIds.has(id)) remember();
    }
  });
  if (dismissed || ['cart','customers/login','customers/register','policy'].includes(entry?.dataset.mfPageType) || location.pathname.includes('/account') || /support|warranty|contact|operation-guide|user-manual/.test(location.pathname)) return;
  const selection = document.querySelector('[data-mf-selection]') || document.querySelector('#MainContent');
  if (!selection) return;
  const timeKey = 'morfone-subscribe-browse-ms-v1';
  let savedMs = 0;
  try { savedMs = Math.min(45000, Math.max(0, Number(sessionStorage.getItem(timeKey)) || 0)); } catch (_) {}
  let seenSelection = false, foregroundMs = savedMs, lastTick = performance.now();
  const persistClock = () => { try { sessionStorage.setItem(timeKey, String(Math.min(45000, foregroundMs))); } catch (_) {} };
  let foreground = !document.hidden && document.hasFocus();
  let lastInteraction = performance.now(), loaded = false, interval;
  const tickClock = () => {
    const now = performance.now();
    if (foreground) foregroundMs += Math.max(0, Math.min(now - lastTick, 1500));
    persistClock();
    lastTick = now;
    foreground = !document.hidden && document.hasFocus();
  };
  document.addEventListener('visibilitychange', tickClock);
  window.addEventListener('pagehide', tickClock);
  window.addEventListener('focus', tickClock);
  window.addEventListener('blur', tickClock);
  const interact = () => { lastInteraction = performance.now(); };
  ['pointerdown', 'keydown', 'input', 'scroll', 'touchstart'].forEach(type => document.addEventListener(type, interact, { capture: true, passive: true }));
  const visible = element => {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true' || !element.getClientRects().length) return false;
    const style = getComputedStyle(element);
    return style.visibility !== 'hidden' && style.display !== 'none';
  };
  const busy = () => {
    if (document.activeElement?.matches('input,textarea,select,[contenteditable="true"],iframe')) return true;
    if ([...document.querySelectorAll('video,audio')].some(media => !media.paused && !media.ended)) return true;
    if (document.querySelector('[data-mf-home][data-preview-open="true"]')) return true;
    const blockers = 'dialog[open],[role="dialog"],[aria-modal="true"],#shopify-pc__banner,#shopify-pc__prefs,.shopify-pc__banner__dialog,#onetrust-banner-sdk,#CybotCookiebotDialog';
    return [...document.querySelectorAll(blockers)].some(visible);
  };
  const markSelection = () => {
    const rect = selection.getBoundingClientRect();
    if (rect.top < innerHeight && rect.bottom > 0 && visible(selection) && (entry?.dataset.mfSubscribeHome === 'true' || scrollY > 160)) seenSelection = true;
  };
  const observer = entry?.dataset.mfSubscribeHome === 'true' && 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    if (entries.some(item => item.isIntersecting)) { seenSelection = true; observer.disconnect(); }
  }, { threshold: 0 }) : null;
  observer?.observe(selection);
  const qualify = () => {
    tickClock();
    if (dismissed || loaded) { clearInterval(interval); observer?.disconnect(); return; }
    if (!observer) markSelection();
    if (!foreground || foregroundMs < 45000 || !seenSelection || performance.now() - lastInteraction < 1500 || busy()) return;
    // Never inject another copy. Another integration loading it early must be fixed at its source.
    if (document.querySelector('script[src*="klaviyo.com/onsite/js/"]')) { loaded = true; clearInterval(interval); return; }
    loaded = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=StWn6c';
    script.dataset.mfDelayedKlaviyo = 'true';
    document.head.appendChild(script);
    clearInterval(interval);
    observer?.disconnect();
  };
  interval = setInterval(qualify, 500);
  // BFCache restores the original clock; hidden time never qualifies as browsing.
  window.addEventListener('pageshow', () => { lastTick = performance.now(); foreground = !document.hidden && document.hasFocus(); });
})();
